/* eslint-disable */
import vuetify from './vuetify';

const labels = {
    dashboard: 'Dashboard',
    demand: 'Demanda',
    demands: 'Demandas',
    contract: 'Contrato',
    contracts: 'Contratos',
    corporate: 'Societário',
    brand: 'Marca',
    brands: 'Marcas',
    department: 'Departamento',
    departments: 'Departamentos',
    teamMember: 'Colaborador',
    teamMembers: 'Colaboradores',
    legalTeam: 'Jurídico',
    notification: 'Notificação',
    notifications: 'Notificações',
    portfolio: 'Portfolio',
    portfolios: 'Portfolios',
    teamMemberPortfolio: 'Equipe',
    activeDemands: 'Demandas Ativas',
    demandsCompleted: 'Demandas Finalizadas',
    workedHours: 'Horas Trabalhadas',
    info: 'Informações',
    timeline: 'Timeline'
};

const common = {
    meta: {
        title: 'Tasklaw - %page',
        description: 'Com nossa calculadora societária você gerencia seu captable, stock options, e informações sobre sua participação na empresa, considerando o tamanho da rodada, a avaliação e outros fatores.',
        keywords: 'calculadora,societaria,captable,equity,stock,empresa,options,jurídico,ações,quotas,percentual,software,sócios,acionistas,rodada,investimento,gráfico,histórico,societário,capital,participação,sociedade'
    },
    filter: {
        componentName: 'Filtros',
        searchFor: 'Pesquisar',
        byCompany: 'Filtrar por empresa',
        byDepartment: 'Filtrar por departamento',
        byResponsible: 'Filtrar por responsável',
        clearFilter: 'Limpar filtro',
        applyFilter: 'Aplicar filtro'
    },
    search: {
        field: 'Pesquisar',
        button: 'Buscar'
    },
    showInactives: 'Exibir inativos?',
    dataTable: {
        headers: {
            name: 'Nome',
            activeDemands: labels.activeDemands,
            demandsCompleted: labels.demandsCompleted,
            workedHours: labels.workedHours,
            actions: 'Ações'
        },
        loadingText: 'Carregando... por favor espere',
        noDataText: 'Nenhum registro encontrado',
        deleteConfirm: 'Tem certeza de que deseja excluir este',
        view: 'Visualizar'
    },
    save: 'Salvar',
    add: 'Adicionar',
    edit: 'Editar',
    change: 'Alterar',
    close: 'Fechar',
    update: 'Atualizar',
    cancel: 'Cancelar',
    confirm: 'Confirmar',
    remove: 'Remover',
    details: 'Detalhes',
    delete: 'Excluir',
    previous: 'Anterior',
    next: 'Próximo',
    notInformed: 'Não Informado',
    yes: 'Sim',
    no: 'Não',
    loadMore: 'Carregar mais',
    editorEmptyNodeText: 'Escreva uma pergunta ou atualização...',
    editorObservationEmptyNodeText: 'Escreva uma observação...',
    noDataText: 'Nenhum registro encontrado',
    timeline: {
        componentName: labels.timeline,
        newInteraction: 'Nova Interação',
        correctDate: {
            label: 'Data de Início (Obrigatório)',
            rule: 'Data de início é obrigatório'
        },
        category: {
            label: 'Categoria (Obrigatória)',
            labelFilter: 'Filtrar por categoria',
            rule: 'Categoria é obrigatória',
            items: {
                noteFile: 'Anotação/Arquivo',
                meeting: 'Reunião',
                phone: 'Telefonema',
                email: 'E-mail',
                charge: 'Cobrança'
            }
        },
        alerts: {        
            saveError: 'Não foi possível salvar a interação',
            addCommentOrFile: 'Adicione um Comentário ou um Arquivo',
            deleteConfirm: 'Tem certeza de que deseja excluir esta Interação?',
            deleteSuccess: 'Interação removida com sucesso!'
        }
    },
    tabDemands: {
        addItem: 'Cadastrar Demanda',
        tabs: {
            actives: 'Ativas',
            completeds: 'Finalizadas',
            standby: 'Standby'
        },
        dataTable: {
            headers: {
                client: 'Cliente',
                startDate: 'Início',
                demand: labels.demand,
                currentTask: 'Tarefa Atual',
                nextTask: 'Próxima Tarefa',
                deadlineDate: 'Prazo',
                status: 'Status',
                workedHours: 'Horas Trabalhadas',
                endDate: 'Data de Conclusão',
                responsibleName: 'Responsável',
            }
        }
    },
    checkAll: 'Marcar tudo',
    uncheckAll: 'Desmarcar tudo',
    fileInfo: {
        delete: 'Excluir',
        download: 'Download',
        confirm: 'Tem certeza de que deseja excluir o arquivo',
        success: 'Arquivo removido com sucesso'
    },
    chat: {
        action: 'Utilizar IA',
        title: 'Chat',
        you: 'Você',
        system: 'Sistema',
        message: 'Digite sua mensagem',
        error: 'Ocorreu um erro!'
    },
    errorSave: 'Ocorreu um erro ao salvar!',
    admin: 'Administrador',
    noAdmin: 'Não administrador'
}

// ok
const demand = {
    status: {
        pending: "Pendente",
        starting: "Iniciado",
        waiting: "Aguardando",
        standby: "Standby",
        finished: "Finalizado",
        canceled: "Cancelado",
    },
    list: {
        meta: {
            title: common.meta.title.replace('%page', labels.demands),
            description: common.meta.description,
            keywords: common.meta.keywords
        },
        filter: {
            fromDate: 'Filtrar por prazo inicial',
            toDate: 'Filtrar por prazo Final',
            client: 'Filtrar por empresa',
            department: 'Filtrar por departamento',
            manager: 'Filtrar por parceiro',
            responsible: 'Filtrar por responsável',
            status: 'Filtrar por status'
        },
        addItem: 'Cadastrar Demanda',
        dataTable: {
            itemName: labels.demand.toLowerCase(),
            headers: {
                client: 'Empresa',
                startDate: 'Início',
                demand: labels.demand,
                currentTask: 'Tarefa Atual',
                nextTask: 'Próxima Tarefa',
                deadlineDate: 'Prazo',
                status: 'Status',
                responsible: 'Responsável'
            }
        }
    },
    form: {
        metaNew: {
            title: common.meta.title.replace('%page', 'Cadastrar Demanda'),
            description: common.meta.description,
            keywords: common.meta.keywords
        },
        metaDetail: {
            title: common.meta.title.replace('%page', 'Detalhe Demanda'),
            description: common.meta.description,
            keywords: common.meta.keywords
        },
        titleNew: 'Nova Demanda',
        titleDetail: 'Detalhe Demanda',
        data: 'Dados da Demanda',
        isExternalDemand: 'Essa demanda é externa?',
        demand: {
            label: 'Demanda (Obrigatório)',
            required: 'Demanda é obrigatório',
            length: 'A demanda deve ter ao menos de 3 caracteres'
        },
        requester: {
            label: 'Solicitante'
        },
        client: {
            label: 'Pesquisar cliente (Obrigatório)',
            required: 'Cliente é obrigatório'
        },
        department: {
            label: 'Pesquisar departamento'
        },
        responsible: {
            label: 'Pesquisar responsáveis (Obrigatório)',
            length: 'Responsáveis é obrigatório'
        },
        status: {
            label: 'Status (Obrigatório)',
            required: 'Status é obrigatório'
        },
        startDate: {
            label: 'Data de Início (Obrigatório)',
            required: 'Data de início é obrigatório'
        },
        deadlineDate: {
            label: 'Data de Prazo',
            labelRequired: 'Data de Prazo (Obrigatório)',
            required: 'Data de prazo é obrigatório'
        },
        manager: {
            label: 'Pesquisar parceiro (Obrigatório)',
            required: 'Parceiro é obrigatório'
        },
        workedHours: {
            label: 'Horas Trabalhadas',
            data: 'Novo registro de hora trabalhada',
            time: {
                label: 'Horas Trabalhadas',
                rule: 'Hora trabalhada é obrigatório'
            },
            registerDate: {
                label: 'Data de Registro (Obrigatório)',
                rule: 'Data de registro é obrigatório'
            }
        },
        tasks: {
            data: 'Tarefas',
            task: {
                label: 'Nova Tarefa',
                rule: 'Hora trabalhada é obrigatório'
            },
            hideDoneTasks: 'Ocultar tarefas concluidas',
            showDoneTasks: 'Ver tarefas concluidas'
        },
        timeline: {
            isPrivate: 'Privado',
            totalFiles: 'Total de arquivos:',
            correctDate: {
                label: 'Data (Obrigatório)',
                rule: 'Data é obrigatório'
            },
            confirm: 'Tem certeza de que deseja excluir esta Interação?',
            success: 'Interação removida com sucesso!',
            errors: {
                save: 'Não foi possivel salvar a interação',
                commentFile: 'Adicione um Comentário ou um Arquivo'
            }
        }
    }
}

// ok
const contracts = {
    status: {
        items: {
            draft: 'Minutas',
            signatures: 'Assinaturas',
            active: 'Vigente',
            renewal: 'Renovação',
            rescinded: 'Rescindido',
            terminated: 'Extinto'
        }
    },
    list: {
        meta: {
            title: 'Tasklaw - Contratos',
            description: common.meta.description,
            keywords: common.meta.keywords
        },
        filter: {
            fromDate: 'Filtrar por vigência inicial',
            toDate: 'Filtrar por vigência Final',
            status: 'Filtrar por Status',
            part: 'Filtrar por parte',
            department: 'Filtrar por departamento',
            client: 'Filtrar por empresa'
        },
        addItem: 'Cadastrar Contrato',
        dataTable: {
            itemName: labels.contract.toLowerCase(),
            headers: {
                client: 'Empresa',
                department: 'Departamento',
                contract: 'Contrato',
                typePart: 'Minha Parte',
                part: 'Parte Principal',
                deadline: 'Prazo Atual',
                validity: 'Vigência',
                status: 'Status',
                pendingAdditive: 'Aditivo Pendente',
                actions: common.dataTable.headers.actions
            }
        },
        successDelete: 'Contrato removido com sucesso!',
        error: 'Ocorreu um erro!',
        deleteMsg: 'Marca removida com sucesso!'
    },
    form: {
        metaNew: {
            title: 'Tasklaw - Novo Contrato',
            description: common.meta.description,
            keywords: common.meta.keywords
        },
        metaDetail: {
            title: 'Tasklaw - Detalhe do Contrato',
            description: common.meta.description,
            keywords: common.meta.keywords
        },
        titleNew: 'Novo Contrato',
        titleDetail: 'Detalhe do Contrato',
        data: 'Dados do Contrato',
        contract: {
            label: 'Contrato (Obrigatório)',
            required: 'Contrato é obrigatório',
            length: 'O contrato deve ter ao menos de 3 caracteres'
        },
        client: {
            label: 'Pesquisar empresa (Obrigatório)',
            required: 'Empresa é obrigatório'
        },
        department: {
            label: 'Pesquisar departamento'
        },
        partField: {
            label: 'Parte (Obrigatório)',
            required: 'Parte é obrigatório'
        },
        typePart: {
            label: 'Parte (Obrigatório)',
            required: 'Outra parte é obrigatório',
            length: 'A parte deve ter ao menos de 3 caracteres'
        },
        validity: {
            switch: 'Vigência indeterminada?',
            label: 'Vigência do contrato (Obrigatório)',
            required: 'Vigência do contrato é obrigatório',
            dateRequired: 'Data de vigência é obrigatório'
        },
        status: {
            label: 'Status (Obrigatório)',
            required: 'Status é obrigatório'
        },
        observation: 'Observações',
        objectContract: {
            label: 'Objeto do Contrato',
            required: 'Objeto do contrato é obrigatório'
        },
        part: {
            title: 'Outras partes do Contrato',
            empty: 'Nenhuma parte registrada neste contrato!',
            isMainPart: '(Parte Principal)',
            setMainPart: 'Tornar principal',
            showOnlyMainPart: 'Exibir somente a principal',
            showAllParts: 'Ver todas as partes do contrato'
        },
        partDialog: {
            title: 'Nova parte do contrato',
            type: {
                label: 'Parte',
                required: 'Parte é obrigatório',
                length: 'A parte deve ter ao menos de 3 caracteres',
            },
            name: {
                label: 'Nome da Parte',
                required: 'O nome da parte é obrigatório',
                length: 'O nome da parte deve ter ao menos de 3 caracteres'
            },
            part: {
                label: 'Parte'
            }
        },
        fileUpload: {
            title: 'Arquivo do Contrato',
            empty: 'Nenhum arquivo anexado!',
            tip: 'Arraste e solte o arquivo aqui ou clique no botão abaixo.',
            action: 'Anexar'
        },
        deadline: {
            title: 'Prazos do Contrato',
            empty: 'Nenhuma prazo registrado neste contrato!', 
            hideDones: 'Ocultar prazos concluídos',
            showDones: 'Ver prazos concluídos'
        },
        deadlineDialog: {
            title: 'Nova prazo do contrato',
            deadline: {
                label: 'Data do Prazo (Obrigatório)',
                required: 'Data do prazo é obrigatório'
            },
            name: {
                label: "Novo Prazo",
                required: 'Nome do prazo é obrigatório',
                length: 'O nome do prazo deve ter ao menos de 3 caracteres'
            }
        },
        additive: {
            title: 'Aditivos do Contrato',
            empty: 'Nenhum aditivo registrado neste contrato!',
            status: 'Status do Aditivo:',
            signDate: 'Data da assinatura:',
            cancelDate: 'Data do cancelamento:',
            hideCanceleds: 'Ocultar aditivos cancelados',
            showCanceleds: 'Exibir aditivos cancelados'
        },
        additiveDialog: {
            title: 'Aditivo do Contrato',
            empty: 'Nenhum objeto de contrato anexado!',
            additive: {
                label: 'Nome (Obrigatório)',
                required: 'Nome é obrigatório',
                length: 'O nome deve ter ao menos de 3 caracteres'
            },
            description: 'Descrição e objeto do Aditivo',
            reasonCancellation: {
                label: 'Razão do Cancelamento (Obrigatório)',
                required: 'Razão do cancelamento é obrigatório'
            },
            addendumDate: {
                label: 'Data de criação (Obrigatório)',
                required: 'Data da criação do aditivo é obrigatório'
            },
            signatureDate: {
                label: 'Data da assinatura (Obrigatório)',
                required: 'Data da assinatura do aditivo é obrigatório'
            },
            cancellationDate: {
                label: 'Data do Cancelamento (Obrigatório)',
                required: 'Data do cancelmento do aditivo é obrigatório'
            },
            status: {
                label: 'Status (Obrigatório)',
                required: 'Status é obrigatório',
                items: {
                    pending: 'Pendente',
                    sign: 'Assinado',
                    canceled: 'Cancelado'
                }
            }
        }
    }
};

// ok
const corporate = {
    meta: {
        title: 'Tasklaw - Societário',
        description: common.meta.description,
        keywords: common.meta.keywords
    },
    tabs: {
        captable: 'Captable',
        administration: 'Administração',
        constitutiveActs: 'Atos Constitutivos'
    },
    client: {
        label: common.filter.byCompany,
    },
    captable: {
        companyInfo: {
            update: 'Atualizar Dados',
            socialReason: 'Razão Social',
            socialObjects: 'Objetos Sociais',
            CNAES: 'CNAES',
            headquarters: 'Sede',
            companyType: {
                label: 'Tipo Societário',
                required: 'Tipo societário é obrigatório',
                items: {
                    sa: 'SA',
                    ltda: 'Ltda'
                }
            },
            meetingDate: {
                label: 'Data para AGO',
                required: 'Data é obrigatório'
            },
            shareCapitalLabel: 'Total de Ações',
            totalActions: 'Total de Ações',
            totalQuotas: 'Total de Quotas',
            agoDate: 'Data para AGO',
            partnersMeetingDate: 'Data para Reunião de Sócios'
        },
        current: {
            title: 'Captable Atual',
            empty: 'Sem entrada atual no momento!',
        },
        history: {
            title: 'Histórico do Captable',
            empty: 'Sem histórico no momento!',
            headers: {
                shareholder: 'Acionista',
                actions: 'Ações',
                percentual: '%',
                partners: 'Sócios',
                quotas: 'Quotas'
            },
            total: 'Total',
            deleteConfirm: 'Tem certeza de que deseja excluir este Captable?',
            deleteSuccess: 'Captable excluído com sucesso!'
        },
        form: {
            titleNew: 'Nova Entrada',
            titleDetail: 'Detalhe Entrada',
            data: 'Dados da Entrada',
            memberTypeShareholders: 'Acionistas',
            shareTypeActions: 'Ações',
            memberTypePartners: 'Sócios',
            shareTypeQuotas: 'Quotas',
            shareCapitalInitial: 'Quotas Iniciais',
            shareCapitalBase: 'Quotas Atualizadas',
            buttonLabelAdd: 'Adicionar',
            buttonLabelEdit: 'Editar',
            groupEntry: 'Entrada % em grupo?',
            columns: {
                name: 'Nome',
                percentual: 'Percentual',
                shares: 'Ações',
                stakes: 'Quotas'
            },
            empty: 'Nenhum membro registrado!',
            shareNumberRounded: '* O número de %form.shareType% são arredondados para o número inteiro mais próximo *',
            unlockChanges: 'Desbloquear alterações',
            lockChanges: 'Bloquear alterações',
            calc: 'Calcular',
            reInit: 'Reiniciar',
            title: {
                label: 'Título (Obrigatório)',
                required: 'Título é obrigatório',
                length: 'O título deve ter ao menos de 3 caracteres'
            },
            shareCapitalInitial: {
                label: 'Ações Iniciais',
                required: 'Ações inciais é obrigatório',
                length: 'O ações inciais precisa ser positivo'
            },
            shareCapitalBase: {
                label: 'Ações Atualizadas',
                required: 'Ações atualizadas é obrigatório',
                length: 'O ações atualizadas precisa ser positivo'
            },
            required: 'Obrigatório',
            member: {
                required: 'member é obrigatório',
                length: 'O título deve ter ao menos de 3 caracteres'
            },
            shares: {
                required: 'share é obrigatório',
                length: 'share precisa ser positivo'
            },
            percentual: {
                required: 'percentual é obrigatório',
                length: 'percentual precisa ser positivo',
                lengthMore: 'percentual não pode ultrapassar de 100%'
            },
            fixedError: 'Cálculo incorreto: a soma dos percentuais a serem fixados é 100% ou acima!',
            addedError: 'Cálculo incorreto: a soma dos percentuais a serem adicionados é 100% ou acima!',
            fixedAddedError: 'Cálculo incorreto: a soma dos percentuais a serem adicionados e fixados é 100% ou acima!',
            missingMembers: 'É necessário adicionar os membros!'
        }
    },
    administration: {
        titleSA: 'Conselho de Administração',
        titleLTDA: 'Diretores/Adminitradores',
        current: {
            empty: 'Sem membros no momento!',
        },
        history: {
            title: 'Histórico de %title%',
            empty: 'Sem histórico no momento!',
            registerDate: 'Data do Registro:',
            admitted: 'Admitidos',
            destitute: 'Destituídos',
            headers: {
                name: 'Diretores/Adminitradores',
                nameSA: 'Conselho de Administração',
                position: 'Cargo',
                election: 'Eleição',
                mandate: 'Mandato',
                deprived: 'Destiuído'
            },
            deleteConfirm: 'Tem certeza de que deseja excluir este registro?',
            deleteSuccess: 'Registro excluído com sucesso!'
        },
        form: {
            titleNew: 'Nova Entrada',
            titleDetail: 'Detalhe Entrada',
            data: 'Dados da Entrada',
            memberTypeLTDA: 'Diretores/Administradores',
            memberTypeSA: 'Conselho de Administração',
            admitted: '(Admitidos)',
            destitute: '(Destituídos)',
            empty: 'Nenhum membro registrado!',
            dismiss: 'Destituir',
            refund: 'Restituir',
            date: {
                label: 'Data do Registro (Obrigatório)',
                required: 'Data do Registro é obrigatória'
            },
            member: {
                label: 'Nome (Obrigatório)',
                required: 'Nome é obrigatório',
                length: 'O nome deve ter ao menos de 3 caracteres'
            },
            position: {
                label: 'Cargo (Obrigatório)',
                required: 'Cargo é obrigatório',
                length: 'O cargo deve ter ao menos de 3 caracteres'
            },
            mandate: {
                label: 'Mandato indeterminado?',
                required: 'Data do mandato é obrigatório',
                length: 'O mandato deve ter ao menos de 3 caracteres',
                undetermined: 'Indeterminado'
            },
            election: {
                label: 'Eleição (Obrigatório)',
                required: 'Data da eleição é obrigatório'
            },
            deprived: {
                label: 'Destituição (Obrigatório)',
                required: 'Data da destituição é obrigatório'
            }
        }
    },
    constitutiveActs: {
        fromDate: 'Depois de',
        toDate: 'Antes de',
        dataTable: {
            itemName: 'Ato Constitutivo',
            headers: {
                date: 'Data',
                title: 'Título',
                resume: 'Resumo',
                file: 'Anexo',
                actions: 'Ações'
            }
        },
        form: {
            header: 'Ato Constitutivo',
            filePreviewEmpty: 'Nenhum arquivo de ato anexado!',
            title: {
                label: 'Título (Obrigatório)',
                required: 'Título é obrigatório',
                length: 'O título deve ter ao menos de 3 caracteres'
            },
            description: {
                label: 'Resumo e arquivo do Ato',
            },
            time: {
                label: 'Hora (Obrigatório)',
                required: 'Hora é obrigatório'
            },
            date: {
                label: 'Data (Obrigatório)',
                required: 'Data é obrigatória'
            },
            needFile: 'É necessário anexar um arquivo.',
            needResume: 'É necessário preencher o resumo.'
        }
    }
}

const generic = {
    title: "Notificações",
    filterByCompany: "Filtrar por empresa",
    search: "Pesquisar",
    applyFilter: "Aplicar filtro",
    clearFilter: "Limpar filtro",
    team: "Jurídico",
    required: "(Obrigatório)",
    search: "Pesquisar",
    find: "Buscar",
    add: "Adicionar",
    save: "Salvar",
    title: "Departamentos",
    required: "(Obrigatório)",
    search: "Pesquisar",
    find: "Buscar",
    add: "Cadastrar departamento",
    save: "Salvar",
    yes: "Sim",
    no: "Não",
    title: "Empresas",
    required: "(Obrigatório)",
    search: "Pesquisar",
    find: "Buscar",
    add: "Cadastrar Empresa",
    save: "Salvar",
    title: "Marcas",
    required: "(Obrigatório)",
    search: "Pesquisar",
    filterByCompany: "Filtrar por empresa",
    find: "Buscar",
    update: "Atualizar",
    add: "Cadastrar Marca",
    save: "Salvar",
    activeDemands: 'Demandas Ativas',
    finishedDemands: 'Demandas Finalizadas',
    workedHours: 'Horas Trabalhadas',
    actions: 'Ações',
}

const administration = {
    meta: {
        title: "Tasklaw - Administração",
        description: "Com nossa calculadora societária você gerencia seu captable, stock options, e informações sobre sua participação na empresa, considerando o tamanho da rodada, a avaliação e outros fatores.",
        keywords: "calculadora,societaria,captable,equity,stock,empresa,options,jurídico,ações,quotas,percentual,software,sócios,acionistas,rodada,investimento,gráfico,histórico,societário,capital,participação,sociedade"
    },
    list: {
        boardAdmin: "Diretores/Administradores",
        position: "Cargo",
        election: "Eleição",
        term: "Mandato",
        dismissed: "Destiuído",
        boardOfDirectors: "Conselho de Administração",
        areYouSureWantDelete: "Tem certeza de que deseja excluir este registro?",
        entryDeleted: "Registro excluído com sucesso!",
        error: "Ocorreu algum erro!",
    },
    form: {
        save: "Salvar",
        entryData: "Dados da Entrada",
        admitted: "Admitidos",
        add: "Adicionar",
        noMember: "Nenhum membro registrado!",
        termIndetermined: "Mandato indeterminado?",
        destitute: "Destituir",
        remove: "Remover",
        dismissed: "Destituídos",
        restitute: "Restituir",
        dismissal: "Destituição",
        cancel: "Cancelar",
        confirm: "Confirmar",
        newEntry: "Nova Entrada",
        name: "Nome",
        position: "Cargo",
        entryDate: "Data do Registro",
        memberRequired: "member é obrigatório",
        titleMinSize: "O título deve ter ao menos de 3 caracteres",
        positionRequired: "Cargo é obrigatório",
        positionMinSize: "O cargo deve ter ao menos de 3 caracteres",
        termRequired: "Mandato é obrigatório",
        termMinSize: "O mandato deve ter ao menos de 3 caracteres",
        entryDetail: "Detalhe Entrada",
        boardOfDirectors: "Conselho de Administração",
        election: "Eleição",
        electionDate: "Data da eleição é obrigatório",
        term: "Mandato",
        termDate: "Data do mandato é obrigatório",
        dismissalRequired: "Data da destituição é obrigatório",
        errorSave: "Ocorreu um erro ao salvar!",
        indetermined: "Indeterminado",
        
        boardAdmin: "Diretores/Administradores",
        nonTaxpayer: "Não contribuinte",
        brazil: "Brasil",
        legal: "Jurídica",
    }
};

const captable = {
    meta: {
        title: "Tasklaw - Captable",
        description: "Com nossa calculadora societária você gerencia seu captable, stock options, e informações sobre sua participação na empresa, considerando o tamanho da rodada, a avaliação e outros fatores.",
        keywords: "calculadora,societaria,captable,equity,stock,empresa,options,jurídico,ações,quotas,percentual,software,sócios,acionistas,rodada,investimento,gráfico,histórico,societário,capital,participação,sociedade"
    },
    generic: {
        required: "(Obrigatório)",
        isRequired: "é obrigatório",
        demand: "Demanda",
        search: "Pesquisar",
        find: "Buscar",
        status: "Status",
        actions: "Ações",
        save: "Salvar",
        mainPart: "Parte Principal"
    },
    captableList: {
        delete: "Excluir",
        edit: "Editar",
        shareholder: "Acionista",
        shares: "Ações",
        partnerrs: "Sócios",
        stakes: "Quotas",
        total: "Total",
        areYouSureWantDelete: "Tem certeza de que deseja excluir este Captable?",
        sucessDelete: "Captable excluído com sucesso",
        error: "Ocorreu algum erro!",
        
        captableHistory: "Histórico do Captable",
        noHistory: "Sem histórico no momento!",
    },
    captableForm: {
        entryData: "Dados da Entrada",
        groupEntry: "Entrada % em grupo?",
        add: "Adicionar",
        name: "Nome",
        percentual: "Percentual",
        noMembers: "Nenhum membro registrado!",
        shareNumberRounded: "* O número de {{ form.shareType }} são arredondados para o número inteiro mais próximo *",
        unlockEdit: "Desbloquear alterações",
        blockEdit: "Bloquear alterações",
        calc: "Calcular",
        restart: "Reiniciar",
        newEntry: "Nova Entrada",
        shareholders: "Acionistas",
        shares: "Ações",
        title: "Título",
        initialShares: "Ações Iniciais",
        updatedShares: "Ações Atualizadas",
        titleMinSize: "O título deve ter ao menos de 3 caracteres",
        sharesPositive: "O ações inciais precisa ser positivo",
        sharesUpdatedPositive: "O ações atualizadas precisa ser positivo",
        memberRequired: "member é obrigatório",
        stakesRequired: "share é obrigatório",
        stakesPositive: "share precisa ser positivo",
        percentualRequired: "percentual é obrigatório",
        percentualPositive: "percentual precisa ser positivo",
        percentualWrongCalc: "percentual não pode ultrapassar de 100%",
        
        entryDetail: "Detalhe Entrada",
        partners: "Sócios",
        stakes: "Quotas",
        initialStakes: "Quotas Iniciais",
        updatedStakes: "Quotas Atualizadas",
        errorCalc1: "Cálculo incorreto a soma dos percentuais a serem fixados é 100% ou acima!",
        errorCalc2: "Cálculo incorreto a soma dos percentuais a serem adicionados é 100% ou acima!",
        errorCalc3: "Cálculo incorreto a soma dos percentuais a serem adicionados e fixados é 100% ou acima!",
        necessaryAddMembers: "É necessário adicionar os membros!",
        saveError: "Ocorreu um erro ao salvar"
    }
};

const corporation = {
    meta: {
        title: "Tasklaw - Societário",
        description: "Com nossa calculadora societária você gerencia seu captable, stock options, e informações sobre sua participação na empresa, considerando o tamanho da rodada, a avaliação e outros fatores.",
        keywords: "calculadora,societaria,captable,equity,stock,empresa,options,jurídico,ações,quotas,percentual,software,sócios,acionistas,rodada,investimento,gráfico,histórico,societário,capital,participação,sociedade"
    },
    generic: {
        required: "(Obrigatório)",
        isRequired: "é obrigatório",
        demand: "Demanda",
        search: "Pesquisar",
        find: "Buscar",
        status: "Status",
        actions: "Ações",
        save: "Salvar",
        mainPart: "Parte Principal"
    },
    menu: {
        captable: "Captable",
        administration: "Administração",
        incorporationArticles: "Atos Constitutivos"
    }
};

const calculator = {
    meta: {
        title: "Tasklaw - Calculadora Societária (Equity / Captable)",
        description: "Com nossa calculadora societária você gerencia seu captable, stock options, e informações sobre sua participação na empresa, considerando o tamanho da rodada, a avaliação e outros fatores.",
        keywords: "calculadora,societaria,captable,equity,stock,empresa,options,jurídico,ações,quotas,percentual,software,sócios,acionistas,rodada,investimento,gráfico,histórico,societário,capital,participação,sociedade"
    },
    generic: {
        required: "(Obrigatório)",
        isRequired: "é obrigatório",
        demand: "Demanda",
        search: "Pesquisar",
        find: "Buscar",
        status: "Status",
        save: "Salvar",
        filterBy: "Filtrar por",
        demandStatus: {
            pending: "Pendente",
            starting: "Iniciado",
            waiting: "Aguardando",
            standby: "Standby",
            finished: "Finalizado",
            canceled: "Cancelado",
        }
    },
    demandList: {
        addDemand: "Cadastrar Demanda",
        company: "Empresa",
        start: "Início",
        currentTask: "Tarefa Atual",
        nextTask: "Próxima Tarefa",
        deadline: "Prazo",
        responsible: "Responsável"
    },
    demandFilter: {
        filter: "Filtros",
        clearFilter: "Limpar Filtro",
        applyFilter: "Aplicar Filtro",
        initialDeadline: "prazo inicial",
        finalDeadline: "prazo Final",
        client: "cliente",
        department: "departamento",
        partner: "parceiro",
        responsible: "Responsável",
        status: "Status",
        checkAll: "Marcar tudo",
        uncheckAll: "Desmarcar tudo"
    },
    demandForm: {
        demandInfo: "Dados da Demanda",
        isExternalDemand: "Essa demanda é externa?",
        newDemand: "Nova Demanda",
        requester: "Solicitante",
        workedHours: "Horas Trabalhadas",
        demandTitleHint: "A demanda deve ter ao menos de 3 caracteres",
        startDate: "Data de Início ",
        deadlineDate: "Data de Prazo ",
        partnerSearch: "Pesquisar parceiro ",
        partnerRequired: "Parceiro é obrigatório",
        clientSearch: "Pesquisar cliente ",
        clientRequired: "Cliente é obrigatório'",
        departmentSearch: "Pesquisar departamento",
        responsibleSearch: "Pesquisar responsáveis ",
        responsibleRequired: "Responsáveis é obrigatório",
        deadlineDate: "Data de Prazo",
        demandDetail: "Detalhe Demanda",
        errorSave: "Ocorreu um erro ao salvar!"
    }
};

const atos = {
    meta: {
        title: 'Tasklaw - Atos Constitutivos',
        description: 'Com nossa calculadora societária você gerencia seu captable, stock options, e informações sobre sua participação na empresa, considerando o tamanho da rodada, a avaliação e outros fatores.',
        keywords: 'calculadora,societaria,captable,equity,stock,empresa,options,jurídico,ações,quotas,percentual,software,sócios,acionistas,rodada,investimento,gráfico,histórico,societário,capital,participação,sociedade'
    },
    generic: {
        required: '(Obrigatório)',
        isRequired: 'é obrigatório',
        demand: 'Demanda',
        search: 'Pesquisar',
        find: 'Buscar',
        status: 'Status',
        actions: 'Ações',
        save: 'Salvar',
        mainPart: 'Parte Principal',
        incorporationArticle: 'Ato Constitutivo',
        title: 'Título',
        date: 'Data',
        hour: 'Hora'
    },
    list: {
        update: 'Atualizar',
        after: 'Depois de',
        before: 'Antes de',
        resume: 'Resumo',
        attachment: 'Anexo',
        actions: 'Ações',
    },
    form: {
        add: 'Adicionar',
        noAttachments: 'Nenhum arquivo de ato anexado!',
        close: 'Fechar',
        tttt: 'Resumo e arquivo do Ato',
        dateIsRequired: 'Data é obrigatória',
        titleIsRequired: 'Título é obrigatório',
        titleMinSize: 'O título deve ter ao menos de 3 caracteres',
        hourRequired: 'Hora é obrigatório',
        attachmentRequired: 'É necessário anexar um arquivo.',
        resumeRequired: 'É necessário preencher o resumo.',
        saveError: 'Ocorreu um erro ao salvar, avise a Mocka!',
        
    }
};

// ok
const brands = {
    list: {
        meta: {
            title: 'Tasklaw - Marcas',
            description: common.meta.description,
            keywords: common.meta.keywords
        },
        addItem: 'Cadastrar Marca',
        dataTable: {
            itemName: labels.brand.toLowerCase(),
            headers: {
                company: 'Empresa',
                process: 'Processo',
                brand: 'Marca',
                presentation: 'Apresentação',
                nature: 'Natureza',
                class: 'Classe',
                situation: 'Situação',
                actions: 'Ações'
            }
        },
        deleteMsg: 'Marca removida com sucesso!'
    },
    form: {
        metaNew: {
            title: 'Tasklaw - Nova Marca',
            description: common.meta.description,
            keywords: common.meta.keywords
        },
        metaDetail: {
            title: 'Tasklaw - Detalhe da Marca',
            description: common.meta.description,
            keywords: common.meta.keywords
        },
        titleNew: 'Nova Marca',
        titleDetail: 'Detalhe Marca',
        data: 'Dados da marca',
        processNo: 'Nº do processo',
        searchINPI: 'Buscar no INPI',
        processNumberRequired: 'Nº Processo (Obrigatório)',
        processNumberIsRequired: 'Nº Processo é obrigatório',
        searchCompanyRequired: 'Pesquisar empresa (Obrigatório)',
        companyIsRequired: 'Empresa é obrigatório',
        inpiError: 'Oops! rolou problema na INPI.',
        processNumber: 'Número do Processo',
        situation: 'Situação',
        brand: 'Marca',
        presentation: 'Apresentação',
        nature: 'Natureza'
    }
};

const client = {
    info: {
        primaryEmail: 'Email princial',
        commercialPhone: 'Telefone comercial',
        cellPhone: 'Telefone celular',
        comments: 'Observações',
        isActive: {
            portfolio: 'O portfolio está ativo?',
            departamento: 'O departamento está ativo?'
        }
    },
    workedHours: {
        fromDate: 'Depois de',
        toDate: 'Antes de',
        responsible: 'Filtrar por Responsável',
        dataTable: {
            itemName: 'hora trabalhada',
            headers: {
                registeredAt: 'Data de Registro',
                demand: 'Demanda',
                workedHour: 'Horas Trabalhadas',
                responsibleName: 'Responsável',
                actions: 'Ações'
            },
            deleteSuccess: 'Hora trabalhada removida com sucesso!'
        }
    },
    contracts: {
        addItem: 'Cadastrar Contrato',
        tabs: {
            active: 'Ativos',
            inactive: 'Inativos'
        },
        dataTable: {
            itemName: 'contrato',
            headers: {
                contract: 'Contrato',
                typePart: 'Parte',
                part: 'Parte Principal',
                deadline: 'Prazo Atual',
                validity: 'Vigência',
                status: 'Status',
                pendingAdditive: 'Aditivo Pendente'
            }
        }
    }
}

// ok
const portfolios = {
    list: {
        meta: {
            title: common.meta.title.replace('%page', labels.portfolios),
            description: common.meta.description,
            keywords: common.meta.keywords
        },
        addItem: 'Cadastrar Portfolio',
        dataTable: {
            itemName: labels.portfolio.toLowerCase(),
            headers: {
                name: common.dataTable.headers.name,
                activeDemands: common.dataTable.headers.activeDemands,
                demandsCompleted: common.dataTable.headers.demandsCompleted,
                workedHours: common.dataTable.headers.workedHours,
                actions: common.dataTable.headers.actions
            }
        }
    },
    form: {
        meta: {
            title: common.meta.title.replace('%page', 'Cadastrar Portfolio'),
            description: common.meta.description,
            keywords: common.meta.keywords
        },
        data: 'Dados do Portfolio',
        name: {
            label: 'Nome do Portfolio (Obrigatório)',
            required: 'Nome é obrigatório',
            length: 'O nome deve ter ao menos de 3 caracteres'
        },
        primaryEmail: {
            label: 'Email princial (Obrigatório)',
            required: 'E-mail é obrigatório',
            test: 'E-mail deve ser válido'
        },
        commercialPhone: 'Telefone comercial',
        cellPhone: 'Telefone celular',
        comments: 'Observações'
    },
    teamMember: {
        addItem: 'Cadastrar Usuário',
        dataTable: {
            itemName: 'usuário',
            headers: {
                name: 'usuário',
                jobTitle: 'Cargo',
                phone: 'Telefone',
                username: 'Email',
                mainAccount: 'Tipo de Acesso',
                actions: 'Ações'
            },
            deleteSuccess: 'Relação removida com sucesso!'
        },
        form: {
            meta: {
                title: common.meta.title.replace('%page', 'Cadastrar Usuário'),
                description: common.meta.description,
                keywords: common.meta.keywords
            },
            data: 'Dados do Usuário',
            name: {
                label: 'Nome (Obrigatório)',
                required: 'Nome é obrigatório',
                length: 'O nome deve ter ao menos de 3 caracteres'
            },
            jobTitle: {
                label: 'Cargo (Obrigatório)',
                required: 'Cargo é obrigatório',
                length: 'O cargo deve ter ao menos de 3 caracteres'
            },
            phone: {
                label: 'Telefone (Obrigatório)',
                required: 'Telefone é obrigatório',
                length: 'O telefone deve ter ao menos de 8 caracteres'
            },
            username: {
                label: 'Email (Obrigatório)',
                required: 'Email é obrigatório',
                test: 'Email deve ser válido'
            },
            pickColor: 'Escolha uma cor',
            mainAccount: {
                label: 'Administrador?',
                required: 'Tipo de Acesso é obrigatório',
                items: {
                    admin: 'Administrador',
                    user: 'Usuário'
                }
            },
            errorUpdateAdmin: 'Ocorreu um erro ao atualizar o status de administrador!',
            errorRelation: 'Ocorreu um erro, o jurídico foi criado porém não foi relacionado a organização!',
            errorCreate: 'Ocorreu um erro e não foi possível criar o jurídico!'
        }
    }
};

// ok
const departments = {
    list: {
        meta: {
            title: common.meta.title.replace('%page', labels.departments),
            description: common.meta.description,
            keywords: common.meta.keywords
        },
        addItem: 'Cadastrar Departamento',
        dataTable: {
            itemName: labels.department.toLowerCase(),
            headers: {
                name: common.dataTable.headers.name,
                activeDemands: common.dataTable.headers.activeDemands,
                demandsCompleted: common.dataTable.headers.demandsCompleted,
                workedHours: common.dataTable.headers.workedHours,
                actions: common.dataTable.headers.actions
            }
        }
    },
    form: {
        meta: {
            title: common.meta.title.replace('%page', 'Cadastrar Departamento'),
            description: common.meta.description,
            keywords: common.meta.keywords
        },
        data: 'Dados do Departamento',
        name: {
            label: 'Nome do Departamento (Obrigatório)',
            required: 'Nome é obrigatório',
            length: 'O nome deve ter ao menos de 3 caracteres'
        },
        primaryEmail: {
            label: 'Email princial (Obrigatório)',
            required: 'E-mail é obrigatório',
            test: 'E-mail deve ser válido'
        },
        commercialPhone: 'Telefone comercial',
        cellPhone: 'Telefone celular',
        comments: 'Observações',
        isActive: 'O departamento está ativo?'
    },
    teamMember: {
        addItem: 'Cadastrar Colaborador',
        dataTable: {
            itemName: 'colaborador',
            headers: {
                name: 'Colaborador',
                mainAccount: 'Tipo de Acesso',
                actions: 'Ações'
            },
            deleteSuccess: 'Relação com departamento removida com sucesso!'
        },
        form: {
            meta: {
                title: common.meta.title.replace('%page', 'Cadastrar Colaborador'),
                description: common.meta.description,
                keywords: common.meta.keywords
            },
            data: 'Dados do Colaborador',
            name: {
                label: 'Nome (Obrigatório)',
                required: 'Nome é obrigatório',
                length: 'O nome deve ter ao menos de 3 caracteres'
            },
            jobTitle: {
                label: 'Cargo (Obrigatório)',
                required: 'Cargo é obrigatório',
                length: 'O cargo deve ter ao menos de 3 caracteres'
            },
            phone: {
                label: 'Telefone (Obrigatório)',
                required: 'Telefone é obrigatório',
                length: 'O telefone deve ter ao menos de 8 caracteres'
            },
            username: {
                label: 'Email (Obrigatório)',
                required: 'Email é obrigatório',
                test: 'Email deve ser válido'
            },
            pickColor: 'Escolha uma cor',
            mainAccount: {
                label: 'Administrador?',
                required: 'Tipo de Acesso é obrigatório',
                items: {
                    admin: 'Administrador',
                    user: 'Usuário'
                }
            },
            errorUpdateAdmin: 'Ocorreu um erro ao atualizar o status de administrador!',
            errorRelation: 'Ocorreu um erro, o usuário foi criado porém não foi relacionado a empresa!',
            errorCreate: 'Ocorreu um erro e não foi possível criar o usuário!',
            errorUploadAvatar: 'Não foi fazer o upload do avatar!'
        }
    }
};

// ok
const legalTeam = {
    list: {
        meta: {
            title: common.meta.title.replace('%page', labels.legalTeam),
            description: common.meta.description,
            keywords: common.meta.keywords
        },
        addItem: 'Cadastrar Jurídico',
        dataTable: {
            itemName: labels.legalTeam.toLowerCase(),
            headers: {
                avatar: 'Avatar',
                name: common.dataTable.headers.name,
                activeDemands: common.dataTable.headers.activeDemands,
                demandsCompleted: common.dataTable.headers.demandsCompleted,
                workedHours: common.dataTable.headers.workedHours,
                actions: common.dataTable.headers.actions
            },
            isInactiveMessage: 'Tem certeza de que deseja desabilitar este',
            isActiveMessage: 'Tem certeza de que deseja habilitar este',
            fbActiveMessage: 'Jurídico habilitado com sucesso!',
            fbInactiveMessage: 'Jurídico desabilitado com sucesso!'
        }
    },
    form: {
        metaNew: {
            title: common.meta.title.replace('%page', 'Cadastrar Jurídico'),
            description: common.meta.description,
            keywords: common.meta.keywords
        },
        metaEdit: {
            title: common.meta.title.replace('%page', 'Editar Jurídico'),
            description: common.meta.description,
            keywords: common.meta.keywords
        },
        data: 'Dados do Jurídico',
        save: common.save,
        avatar: {
            placeholder: 'Avatar',
        },
        name: {
            placeholder: 'Nome (Obrigatório)',
            errors: {
                required: 'Nome é obrigatório',
                length: 'O nome deve ter ao menos de 3 caracteres'
            }
        },
        email: {
            placeholder: 'E-mail (Obrigatório)',
            errors: {
                required: 'E-mail é obrigatório',
                length: 'E-mail deve ser válido'
            }
        },
        jobTitle: {
            placeholder: 'Cargo (Obrigatório)',
            errors: {
                required: 'Cargo é obrigatório',
                length: 'O cargo deve ter ao menos de 3 caracteres'
            }
        },
        phone:  {
            placeholder: 'Telefone (Obrigatório)',
            errors: {
                required: 'Telefone é obrigatório',
                length: 'O telefone deve ter ao menos de 8 caracteres'
            }
        },
        selectColor: 'Escolha uma cor',
        isAdmin: 'É administrador?',
        adminStatusUpdateError: 'Ocorreu um erro ao atualizar o status de administrador!',
        legalCreatedButNotLinkedError: 'Ocorreu um erro, o jurídico foi criado porém não foi relacionado à organização!',
        legalCreationError: 'Ocorreu um erro e não foi possível criar o jurídico!',
        avatarUploadError: 'Não foi possível fazer o upload do avatar!'
    },
    detail: {
        meta: {
            title: common.meta.title.replace('%page', 'Detalhe Jurídico'),
            description: common.meta.description,
            keywords: common.meta.keywords
        },
        tabs: {
            legalTeam: labels.legalTeam,
            demands: labels.demands,
            timeline: labels.timeline
        },
        fields: {
            admin: 'Administrador',
            name: 'Nome',
            email: 'E-mail',
            jobTitle: 'Cargo',
            phone: 'Telefone',
            activeDemands: labels.activeDemands,
            demandsCompleted: labels.demandsCompleted,
            workedHours: labels.workedHours
        }
    }
};

// ok
const notifications = {
    meta: {
        title: common.meta.title.replace('%page', labels.notifications),
        description: common.meta.description,
        keywords: common.meta.keywords
    },
    filter: {
        searchFor: common.filter.searchFor,
        byDepartment: common.filter.byDepartment,
        byResponsible: common.filter.byResponsible,
        clearFilter: common.filter.clearFilter,
        applyFilter: common.filter.applyFilter
    },
    sideMenu: {
        boxes: 'Caixas',
        my: 'Minha',
        distribution: 'Distribuição',
        admin: 'Administrador',
        archived: 'Arquivadas',
        archivedAdmin: 'Arquivadas Administrador'
    },
    dotMenu: {
        markAllRead: 'Marcar todas como lidas',
        archiveAll: 'Arquivar todas'
    },
    tile: {
        demand: labels.demand,
        archiveActions: {
            archive: 'Arquivar',
            unarchive: 'Desarquivar'
        },
        readActions: {
            markRead: 'Marcar como lida',
            markUnread: 'Marcar como não lida'
        },
        lastSeen: 'Ultima visualização do responsável atual em',
        neverSeen: 'Nunca',
        demandNotFound: 'Demanda não encontrada ou removida!'
    }
};

export default {
    labels,
    common,
    demand,
    contracts,
    corporate,
    brands,
    client,
    portfolios,
    departments,
    legalTeam,
    notifications,
    $vuetify: vuetify
}
